import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mapView-container" }
const _hoisted_2 = { class: "mapView-body" }

import {
  reactive,
  computed,
  nextTick,
  onMounted,
  onUnmounted
} from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash'
import { $config } from '@/global/index'
import * as utils from '@/utils'
import commonBorderDialog from '../commonBorderDialog/index.vue';

// 新增 allowExchangeView 参数，默认 false
const defaultMode = 2;

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    characterMode: {},
    allowExchangeView: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

// 默认值
const currCharacterMode = computed(() => props.characterMode ?? defaultMode);
// 取值，无传参默认 false
const allowExchangeView = computed(() => props.allowExchangeView ?? false);

// 状态
const store = useStore();
const state = reactive({
  flag: false,
  ratio: 1,
  roaming: false,
});
const EngineApi = $config.ENGINE_API
const engineName = $config.ENGINE_NAME

// 缓存 minimap 元素，避免重复查DOM
let miniMapEl: HTMLElement | null = null
let engineEl: HTMLElement | null = null

//////////////计算属性//////////////
const stationId = computed(() => {
  return store.state.persistence.stationId;
})
let intervalId: any;

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  removeMiniView();
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null
  }
})

//////////////onMounted//////////////
onMounted(() => {
  window.addEventListener('resize', handleResize);
  miniMapEl = document.getElementById("minimap");
  engineEl = document.getElementById("engineView");
  if (miniMapEl && miniMapEl.getBoundingClientRect().width > 0) {
    getRatio();
    createOrUpdateMiniView();
  } else {
    intervalId = setInterval(() => {
      miniMapEl = document.getElementById("minimap");
      engineEl = document.getElementById("engineView");
      if (miniMapEl && miniMapEl.getBoundingClientRect().width > 0) {
        getRatio();
        createOrUpdateMiniView();
        clearInterval(intervalId);
        intervalId = null;
      }
    }, 200);
  }
})

//////////////方法//////////////
function destroyView() {
  removeMiniView()
  state.flag = false;
}

// 获取缩放比例
function getRatio() {
  let ratio = 1;
  const screen: any = window.screen;
  const ua = navigator.userAgent.toLowerCase();

  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (~ua.indexOf("msie")) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI;
    }
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth;
  }

  // if (ratio) {
  //   ratio = Math.round(ratio * 100);
  // }
  state.ratio = ratio
}

const handleResize = _.debounce(() => {
  getRatio()
  createOrUpdateMiniView()
}, 200);

async function createOrUpdateMiniView(val?: any) {
  await nextTick()
  if (!miniMapEl) return;
  if (!engineEl) return;
  const rect = miniMapEl.getBoundingClientRect();
  const engineRect = engineEl.getBoundingClientRect()

  let top = Math.floor((rect.top - engineRect.top) * state.ratio)
  let left = Math.floor((rect.left - engineRect.left) * state.ratio)
  let width = rect.width * state.ratio
  let height = rect.height * state.ratio

  let data = {
    type: "createOrUpdateSimulateMiniView",
    data: {
      options: {
        viewWidth: Math.ceil(width),
        viewHeight: Math.ceil(height),
        viewUISize: {
          width: Math.ceil(width),
          height: Math.ceil(height)
        },
        position: {
          x: left,
          y: top
        },
        characterMode: currCharacterMode.value,
        cameraPosition: {
          x: 0,
          y: 1,
          z: 3
        },
        cameraRotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        cameraFov: 42
      }
    },
    engineName: engineName
  };
  utils.sendListenerEvent(EngineApi, data);
}

// 销毁小视口
function removeMiniView(id?: any) {
  let data = {
    type: "removeSimulateMiniView",
    data: {
    },
    engineName: engineName
  };
  utils.sendListenerEvent(EngineApi, data);
}

// 双击切换小视口视角：增加权限判断
function handleDBClick() {
  // 只有允许切换时才执行逻辑
  if (!allowExchangeView.value) return

  state.flag = !state.flag
  let data = {
    type: "exchangeSimulateMiniView",
    data: {
      isExchangeView: state.flag
    },
    engineName: engineName
  };
  utils.sendListenerEvent(EngineApi, data);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(commonBorderDialog, { useClipPath: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "mini-map",
            id: "minimap",
            onDblclick: _withModifiers(handleDBClick, ["stop"])
          }, null, 32)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})